import { PriceIndexChartCore } from './Core'
import { PriceIndexChartProps } from './interface'
import { PriceIndexChartStoreProvider } from './Store'

export const PriceIndexChart = ({
  /* -------------------------------------------------------------------------- */
  /*                      PriceIndexChartStoreProviderProps                     */
  /* -------------------------------------------------------------------------- */
  priceIndexType,
  /* -------------------------------------------------------------------------- */
  /*                          PriceIndexChartCoreProps                          */
  /* -------------------------------------------------------------------------- */
  ...coreProps
}: PriceIndexChartProps) => {
  return (
    <PriceIndexChartStoreProvider priceIndexType={priceIndexType}>
      <PriceIndexChartCore {...coreProps} />
    </PriceIndexChartStoreProvider>
  )
}
